export default __webpack_public_path__ + "static/media/3 - Развитие любительского спорта.6feb29a8.jpg";